import { useEffect, useState } from "react";
import ApexCharts from "react-apexcharts";
import Loading from "../../loading";
import { ToastContainer } from "react-toastify";
import Notification from "../../toast";
import reqVenda from "../../../services/reqMultiTenant/reqVenda";

const ChartVendasPeriodo = ({ dtini, dtfim }) => {
	const [vendasCategoria, setVendasCategoria] = useState([]);
	const [valoresFaturamento, setValoresFaturamento] = useState([]);
	const [intervalo, setIntervalo] = useState("1");
	const [loadingVendasPorAno, setLoadingVendasPorAno] = useState(false);

	const options = {
		xaxis: {
			categories: vendasCategoria,
		},
		yaxis: {
			title: {
				text: "Faturamento",
			},
		},
		tooltip: {
			y: {
				formatter: (value) => `R$ ${value.toFixed(2)}`,
			},
		},
		dataLabels: {
			enabled: false,
		},
		colors: ["#3c5f97"],
	};

	const series = [
		{
			name: "Faturamento",
			data: valoresFaturamento,
		},
	];

	useEffect(() => {
		if (intervalo > 0 && dtini && dtfim) listar();
	}, [intervalo, dtini, dtfim]);

	async function listar() {
		try {
			setLoadingVendasPorAno(true);

			const response = await reqVenda.listByYear(intervalo, dtini, dtfim);

			let meses = [
				"Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
				"Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro",
			];

			let categorias = response.data.map((item) => {
				const partes = item.data_inicial.split("-");
				const mes = partes[1];
				return meses[mes - 1]; // TODO: isso funciona para anual. Como fica se for bimestral/trimestral?
				// O backend provavelmente retorna a data do início do período
			});

			let valores = response.data.map((item) => {
				return parseFloat(item.faturamento.replace(",", "."));
			});

			setVendasCategoria(categorias);
			setValoresFaturamento(valores);
		} catch (error) {
			Notification.showToast({
				message: error.message,
				type: "warning",
			});
		} finally {
			setLoadingVendasPorAno(false);
		}
	}

	const getIntervalClass = (val) => {
		return intervalo === String(val)
			? "btn btn-sm btn-primary min-w-[100px]"
			: "btn btn-sm btn-outline-primary min-w-[100px]";
	};

	return (
		<div className="bg-white rounded-md shadow-sm p-4 w-full">
			<ToastContainer />
			
			<div className="flex flex-col sm:flex-row justify-between items-center mb-6">
				<h3 className="text-lg font-medium text-slate-800 m-0">
					Volume Financeiro
				</h3>
				
				<div className="flex bg-slate-100 p-1 rounded-md mt-4 sm:mt-0 gap-1 overflow-x-auto">
					<button
						onClick={() => setIntervalo("1")}
						className={getIntervalClass("1")}
					>
						Mensal
					</button>
					<button
						onClick={() => setIntervalo("2")}
						className={getIntervalClass("2")}
					>
						Bimestral
					</button>
					<button
						onClick={() => setIntervalo("3")}
						className={getIntervalClass("3")}
					>
						Trimestral
					</button>
					<button
						onClick={() => setIntervalo("6")}
						className={getIntervalClass("6")}
					>
						Semestral
					</button>
					<button
						onClick={() => setIntervalo("12")}
						className={getIntervalClass("12")}
					>
						Anual
					</button>
				</div>
			</div>

			{loadingVendasPorAno ? (
				<div className="h-[350px] flex items-center justify-center">
					<Loading mensagem="Buscando Dados..." />
				</div>
			) : (
				<div className="w-full">
					<ApexCharts
						options={options}
						series={series}
						type="bar"
						height={350}
					/>
				</div>
			)}
		</div>
	);
};

export default ChartVendasPeriodo;
